export default __webpack_public_path__ + "a3d4707210671f7f6c3e843552d92a23.svg";